import React from 'react'
import styled from '@emotion/styled'
import { Margins } from 'src/utils/styles'

const DotDividerWraper = styled.span`
  margin: 0 ${Margins.TINY}px;
`

export const DotDivider: React.FC = () => {
  return <DotDividerWraper>·</DotDividerWraper>
}
